import Users from 'svg/Users';

export default Users;
